<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Cancelamento de NF-e"
    :formErrors="formErrors"
    deleteButtonLabel="Cancelar NF-e"
    deleteConfirmButtonLabel="Confirmar Cancelameto da NF-e"
    deleteIcon="mdi-file-cancel"
    :pageLoading="pageLoading"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja cancelar a NF-e de série <b>{{this.entry.series}}</b> e número <b>{{this.entry.number}}</b>, no valor de <b>{{this.entry.vNf  | formatCurrency }}</b>?</p>

    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="cancellationReason"
            label="Razão do cancelamento"
            outlined
            :rules="[requiredRule, minLengthRule(15)]"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      cancellationReason: null,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
  },
  methods: {
    destroyServerEntry: function(nfe) {
      //  console.log("CHAMOU destroy", nfe, this.cancellationReason);
      //  return;
      this.pageLoading = true;
        this.$apollo
          .mutate({
            mutation: CANCEL_AUTHORIZED_NFE_MUTATION,
            variables: {
              id: nfe.id,
              input: {
                nfeCancellationReason: this.cancellationReason
              }
            }
          })
          .then(response => {            
            var errors = response.data.cancelAuthorizedNfpe.errors;
            // console.log(errors);
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.pageLoading = false));
    },
    destroyEntry: function() {
      if (this.$refs.form.validate()){
          this.destroyServerEntry(this.entry);
        }
    },
  }
}
const CANCEL_AUTHORIZED_NFE_MUTATION = gql `
  mutation($id: ID!, $input: CancelAuthorizedNfpeInputObject!) {
    cancelAuthorizedNfpe(id: $id, input: $input) {
      nfpe {
        status
        statusKey
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
